import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { AdminBookPublicationRequest } from '../../requests/platform/admin-book-publication.request';
import { AdminBookPublicationResponse } from '../../responses/platform/admin-book-publication.response';

@Injectable({
  providedIn: 'root'
})

export class AdminBookPublicationService extends CommonService {
  constructor(private http: HttpClient) {
    super();
  }
  private readonly base = environment.urlApiPlatform + 'AdminBookPublication/';

  post(req: AdminBookPublicationRequest): Observable<AdminBookPublicationResponse> {
    const url = this.base + 'List';
    return this.http
      .post<AdminBookPublicationResponse>(url, req, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
